<template>
    <span>
        <label v-if="title" :style="`font-size: ${fontSize}px;`" :class="[tagnew(tagnewid), { 'label-required': required }]" :for="id">
            {{ getTitle() }}

            <b-icon
                v-if="tooltipLabel != null"
                icon="information"
                size="is-small"
                v-tippy
                :title="getT(tooltipLabel)"
            />
        </label>
        <label v-if="!title && tagnewid != undefined" :class="tagnew(tagnewid)" />
    </span>
</template>

<script>
export default {
    props: {
        id: {
            default: null,
        },
        title: {
            default: '',
            type: String,
        },
        disableMLtitle: {
            type: Boolean,
            default: false,
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required: {
            type: Boolean,
            default: false,
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: 'is-right',
        },
        tooltipType: {
            type: String,
            default: 'is-dark',
        },
        tooltipMultilined: {
            type: Boolean,
            default: true,
        },
        tooltipSize: {
            type: String,
            default: 'is-large', // is-small, is-large
        },
        fontSize: {
            type: Number,
            default: 12
        }
    },
    data() {
        return {};
    },
    methods: {
        getTitle() {
            let title = this.disableMLtitle ? this.title : this.getT(this.title);
            if (this.required) title = title + ' *';

            return title;
        },
    },
};
</script>

<style lang="scss" scoped>
label {
    color: #666666;
    font-weight: 600;
}
.label-required {
    color: $primary-color;
}
</style>
